import { render, staticRenderFns } from "./UserInfoPage.vue?vue&type=template&id=5f1fa66f&scoped=true"
import script from "./UserInfoPage.vue?vue&type=script&lang=js"
export * from "./UserInfoPage.vue?vue&type=script&lang=js"
import style0 from "./UserInfoPage.vue?vue&type=style&index=0&id=5f1fa66f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1fa66f",
  null
  
)

export default component.exports